import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_2 = { class: "text-info mr-s1" }

import Notice from '@/components/Notice.vue';
import { TokenNoticeType } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/models/token-notice';
import { useI18n } from 'vue-i18n';
import { formatNumbersMixin } from '@/mixins/format-numbers.mixin';
import { computed } from 'vue';

interface NoticeData {
  icon: string;
  text: string;
  tooltip: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenNotice',
  props: {
    notice: null,
    symbol: null,
    action: null
  },
  emits: ["onSelectToken", "onAddToken"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onSelectToken'): void;
  (e: 'onAddToken'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  notice: TokenNoticeType;
  symbol?: string;
  action: 'addLiquidity' | 'withdraw';
}

const { format } = formatNumbersMixin.methods;
const { t } = useI18n();




const translationPath = `portfolio.easyModeTranslations.${props.action}.tokenNotices`;

const noticesData: Record<TokenNoticeType['type'], NoticeData> = {
  add: {
    icon: 'buy',
    text: t(`${translationPath}.add.text`),
    tooltip: t(`${translationPath}.add.tooltip`),
  },
  select: {
    icon: 'check',
    text: t(`${translationPath}.select.text[1]`),
    tooltip: t(`${translationPath}.select.tooltip`),
  },
  zeroBalance: {
    icon: 'infoOutlined',
    text: t(`${translationPath}.zeroBalance.text`),
    tooltip: null,
  },
  zeroLimit: {
    icon: 'infoOutlined',
    text: t(`${translationPath}.zeroLimit.text`),
    tooltip: t(`${translationPath}.zeroLimit.tooltip`),
  },
  shareTooBig: {
    icon: 'infoOutlined',
    text: t(`${translationPath}.shareTooBig.text`),
    tooltip: null,
  },
  shareTooSmall: {
    icon: 'infoOutlined',
    text: t(`${translationPath}.shareTooSmall.text`),
    tooltip: null,
  },
  notAvailable: {
    icon: 'infoOutlined',
    text: t(`${translationPath}.notAvailable.text`),
    tooltip: null,
  },
};

const noticeData = computed(() => noticesData[props.notice.type]);

return (_ctx: any,_cache: any) => {
  return (__props.notice)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.notice.type !== 'select' && __props.notice.type !== 'add')
          ? (_openBlock(), _createBlock(Notice, {
              key: 0,
              text: _unref(noticeData).text,
              icon: _unref(noticeData).icon || 'infoOutlined',
              tooltip: _unref(noticeData).tooltip
            }, null, 8, ["text", "icon", "tooltip"]))
          : (_openBlock(), _createBlock(Notice, {
              key: 1,
              icon: _unref(noticeData).icon || 'infoOutlined',
              tooltip: _unref(noticeData).tooltip,
              "icon-color": "info"
            }, {
              "notice-text": _withCtx(() => [
                (__props.notice.type === 'add')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('add')) + " " + _toDisplayString(_unref(format)(__props.notice.amount)) + " " + _toDisplayString(__props.symbol), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(noticeData).text), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (__props.notice.type === 'select')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", {
                        class: "text-info clickable mr-s1",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onSelectToken')))
                      }, _toDisplayString(_unref(t)('select')), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(noticeData).text), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["icon", "tooltip"]))
      ]))
    : _createCommentVNode("", true)
}
}

})